<template>
    <div class="page-setting has-bc biz-edit-emplyee-role-comp">
        <div class="tool-bar-mask"></div>
        <div class="page-header">
            <h1>{{$route.meta.title}}</h1>
            <div class="btn-group">
                <button class="default-button publish" @click="saveData">儲存設定</button>
            </div>
        </div>
        <toogle-block>
            <div class="toogle-title" slot="toogle-title">
                職務部門資訊
            </div>
            <div class="toogle-body" slot="toogle-body">
                <div class="role-name">
                    <label class="button-font input-label">
                        <div class="title">
                            <span class="must-fill">*</span> 角色名稱
                        </div>
                        <span v-show="error.roleNameErr" class="error-with-title">{{error.roleNameErr}}</span>
                    </label>
                    <div class="input-arear">
                        <input :class="{error: error.roleNameErr}" type="text" v-model="insertData.roleName" placeholder="請輸入角色名稱">
                    </div>
                </div>
            </div>
        </toogle-block>
        <toogle-block>
            <div class="toogle-title auth-setting" slot="toogle-title">
                權限設定
                <div class="view-instruction">
                    <!-- <router-link :to="{ name: ''}" target="_blank">
                        <img src="@/assets/img/icon/view_gray.svg" alt="">
                        所有功能說明
                    </router-link> -->
                </div>
            </div>
            <div class="toogle-body" slot="toogle-body">
                <block-grey v-for="(list,index) in insertData.authList" :key="index">
                    <div class="block-title" slot="block-title">
                        <checkbox :key="index+componentKey" @click.native="changeAuthSubAllCheckbox(index)" :msg="list.name" :val="index" v-model="authCategory[index]" :isPropChecked="authCategory[index]"></checkbox>
                    </div>
                    <div class="block-body" slot="block-body">
                        <div class="sub-auth" v-for="(subList,sIndex) in list.subModules" :key="sIndex">
                            <div class="auth-name" v-if="subList.functions.length > 0">{{subList.name}}</div>
                            <checkbox @click.native="changeAuthCheckbox(index, sIndex, fIndex)" :msg="funcList.name" :val="funcList.functionCode" v-for="(funcList,fIndex) in subList.functions" :key="fIndex" v-model="funcList.right" :isPropChecked="funcList.right"></checkbox>
                        </div>
                    </div>
                </block-grey>
            </div>
        </toogle-block>
    </div>
</template>
<script>
import ToogleBlock from '@/components/bussiness/widges/tools/toogleBlock.vue';
import BlockGrey from '@/components/bussiness/widges/tools/blockGrey.vue';
import Checkbox from '@/components/bussiness/widges/input/checkbox.vue';

import { mapGetters } from 'vuex'

export default {
    data () {
        return {
            componentKey: 0,
            authFunctionTotal: [],
            authCategory: [],
            insertData: {
                roleId: '',
                roleName: '',
                authList: [],
            },
            error: {
                roleNameErr: '',
            },
        }
    },
    mounted () {
        // 取得詳細
        this.getInfo(this.$route.query.id)
        this.insertData.roleId = this.$route.query.id
    },
    watch: {
        'insertData.roleName' : {
            handler: function (newValue, oldValue) {
                if(newValue != ''){
                    this.error.roleNameErr = ''
                }else{
                    this.error.roleNameErr = '請填寫角色名稱'
                }
            },
            deep: true,
        },
        // 'insertData.authList' : {
        //     handler: function (newValue, oldValue) {
        //         let authList = newValue
        //         this.checkSubCheckBoxHasVal(authList)
        //     },
        //     deep: true,
        // },
        employeeRoleInfo: {
            handler: function (newValue, oldValue) {
                this.insertData.authList = this.employeeRoleInfo.authorityList
                this.insertData.roleName = this.employeeRoleInfo.roleName
                this.getFunctionTotal(this.insertData.authList)
            },
            deep: true,
        },
    },
    methods: {
        getInfo: function (id) {
            this.$store.dispatch('getBizEmployeeRoleInfo', id)
            .then(()=>{
                this.setMainCheckbox()
            })
        },
        checkInput: function () {
            if(this.insertData.roleName == ''){
                this.error.roleNameErr = '請填寫角色名稱'
                return false
            }else{
                return true
            }
        },
        // 編輯角色
        saveData: function () {
            if(this.checkInput()){
                this.$analyticsBiz.logEvent('編輯職務部門', { screen_name: '編輯職務部門'})
                this.$store.dispatch('editBizEmployeeRole', this.insertData)
                .then(res => {
                    if( res.data.status == "SUCCESS" ){
                        this.$store.dispatch('bizGetUserInfo')
                        this.$router.push({ name: 'bizEmployeeRole'})
                    }else{
                        this.$store.dispatch('setAlarmStatus', {status: true,title: res.data.errorMsg,type: 'error'})
                    }
                })
            }
        },
        // 檢查次選單功能是否勾選，無勾選取消打勾主管單
        checkSubCheckBoxHasVal: function (authList) {
            let authCategory = this.authCategory
            for (let i = 0; i < authCategory.length; i++) {
                const checkItem = authCategory[i];
                let count = 0
                if(checkItem){
                    const auth = authList[i];
                    for (let j = 0; j < auth.subModules.length; j++) {
                        const subModule = auth.subModules[j];
                        // console.log(subModule.function.length)
                        // console.log(subModule)
                        for (let k = 0; k < subModule.functions.length; k++) {
                            const functionItem = subModule.functions[k];
                            if(!functionItem.right){
                                count += 1
                                console.log(count)
                                console.log(this.authFunctionTotal[i])
                                if(count === this.authFunctionTotal[i]){
                                    authCategory[i] = false;
                                }
                            }
                        }
                    }
                }
            }
        },
        // 取得主選單有幾個權限設定
        getFunctionTotal: function (authList) {
            for (let i = 0; i < authList.length; i++) {
                const auth = authList[i];
                this.authFunctionTotal[i] = 0
                for (let j = 0; j < auth.subModules.length; j++) {
                    const subModule = auth.subModules[j];
                    this.authFunctionTotal[i] += subModule.functions.length
                }
            }
        },
        changeAuthCheckbox: function (index, sIndex, fIndex) {
            console.log(index)
            // console.log(sIndex)
            // console.log(fIndex)
            if(index !== undefined && sIndex !== undefined && fIndex !== undefined){
                // 被勾選的主權限列表
                let authList = this.insertData.authList[index]
                // 被勾選主列表的次權限列表
                let subList = authList.subModules
                // 被勾選的物件
                let item = authList.subModules[sIndex].functions[fIndex]
                console.log(item)

                // 被勾選物件的權限
                let itemRight = item.right
                // 被勾選物件的Code
                let itemCode = item.functionCode
                // 被勾選物件的相依
                let dependent = item.dependentFunctions
                // 若有相依，找出被相依的物件
                if(dependent.length){
                    for (let i = 0; i < dependent.length; i++) {
                        const dependencyItem = dependent[i];
                        this.setDependency(dependencyItem)
                    }
                }else{
                    this.delDependency(itemCode)
                    this.authCategory[index] = true;
                }

            }else if(index !== undefined){
                this.authCategory[index] = true;
            }
        },
        changeAuthSubAllCheckbox: function (index) {
            if(this.authCategory[index]){
                for(var i=0; i<this.insertData.authList[index].subModules.length; i++ ){
                    for(var j=0; j<this.insertData.authList[index].subModules[i].functions.length; j++ ){
                        this.insertData.authList[index].subModules[i].functions[j].right = false;
                    }
                }
            }else{
                for(var i=0; i<this.insertData.authList[index].subModules.length; i++ ){
                    for(var j=0; j<this.insertData.authList[index].subModules[i].functions.length; j++ ){
                        this.insertData.authList[index].subModules[i].functions[j].right = true;
                    }
                }
            }
        },
        setMainCheckbox: function () {
            let mainChk = this.employeeRoleInfo.authorityList
            for (let i = 0; i < mainChk.length; i++) {
                let subChk = mainChk[i].subModules
                for (let j = 0; j < subChk.length; j++) {
                    if(subChk[j]){
                        let funcChk = subChk[j].functions
                        for (let k = 0; k < funcChk.length; k++) {
                            if(this.authCategory[i] != true && funcChk[k].right){
                                this.changeAuthCheckbox(i)
                                this.componentKey += 1
                            }
                        }
                    }
                }
            }
            
        },
        setDependency: function (dependencyItem) {
            for (let i = 0; i < this.insertData.authList.length; i++) {
                const auth = this.insertData.authList[i];
                // console.log(auth)
                for (let j = 0; j < auth.subModules.length; j++) {
                    const subModule = auth.subModules[j];
                    // console.log(subModule)
                    for (let k = 0; k < subModule.functions.length; k++) {
                        const functionItem = subModule.functions[k];
                        if(dependencyItem === functionItem.functionCode){
                            this.authCategory[i] = true;
                            functionItem.right = true
                        }
                    }
                }
            }
        },
        delDependency: function (itemCode) {
            for (let i = 0; i < this.insertData.authList.length; i++) {
                const auth = this.insertData.authList[i];
                // console.log(auth)
                for (let j = 0; j < auth.subModules.length; j++) {
                    const subModule = auth.subModules[j];
                    // console.log(subModule)
                    for (let k = 0; k < subModule.functions.length; k++) {
                        const functionItem = subModule.functions[k];
                        // console.log(functionItem)
                        for (let l = 0; l < functionItem.dependentFunctions.length; l++) {
                            const element = functionItem.dependentFunctions[l];
                            if(itemCode === element){
                                functionItem.right = false
                            }
                        }
                    }
                }
            }
        },
    },
    computed: {
        ...mapGetters({
            employeeRoleInfo : 'GET_BIZ_EMPLOYEE_ROLE_INFO',
            bizAuth: 'GET_BIZ_AUTH',
        })
    },
    components: {
        ToogleBlock,
        BlockGrey,
        Checkbox,
    }
}
</script>
<style lang="scss">
    .biz-edit-emplyee-role-comp{
        .must-fill-alarm{
            position: relative;
            display: flex;
            align-items: center;
            height: 72px;
            margin-bottom: 20px;
            border-radius: 6px;
            box-shadow: 1px 0 10px 0 rgba(41, 38, 37, 0.02);
            border: solid 1px #f3f3f3;
            background-color: #ffffff;
            color: #676362;
            padding: 0 24px;
            .star{
                color: #fc7171;
                margin: 0 2px;
            }
            img{
                margin-right: 2px;
            }
        }
        span.error{
            right: 0;
            top: -27px;
            left: unset;
            bottom: unset;
        }
        .role-name {
            position: relative;
            width: 424px;
            margin-bottom: 24px;
        }
        
        .auth-setting{
            display: flex;
            align-items: center;
            justify-content: space-between;
            width: 100%;
            .view-instruction, .view-instruction a {
                font-size: 14px;
                font-weight: normal;
                font-stretch: normal;
                font-style: normal;
                line-height: normal;
                letter-spacing: normal;
                color: #676362;
            }
            .view-instruction {
                position: relative;
                right: 48px;
                a{
                    display: flex;
                    align-items: center;
                }
            }
        }

        .block-title {
            .input-checkbox {
                .checkbox-img {
                    margin-right: 8px;
                }
                .msg {
                    font-size: 16px;
                    font-weight: normal;
                    font-stretch: normal;
                    font-style: normal;
                    line-height: normal;
                    letter-spacing: normal;
                    color: #292625;
                }
            }
        }
        .block-body {
            .sub-auth {
                width: 235px;
                margin-right: 12px;
                display: inline-grid;

                .input-checkbox {
                    margin-bottom: 16px;
                    .checkbox-img {
                        margin-right: 8px;
                    }
                    .msg {
                        font-size: 14px;
                        font-weight: normal;
                        font-stretch: normal;
                        font-style: normal;
                        line-height: normal;
                        letter-spacing: normal;
                        color: #676362;
                    }
                }
                .auth-name {
                    font-size: 14px;
                    font-weight: 500;
                    font-stretch: normal;
                    font-style: normal;
                    line-height: 1.29;
                    letter-spacing: normal;
                    margin-bottom: 12px;
                }
                

                
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/bussiness/internalAuth/employeeRole/editEmployeeRoleComp.vue